import { NavLink } from 'react-router-dom';

import { IconChartMatch as ChartMatchSVG } from '../../../core';
import { NavigationTab } from '../types';

import CompactTab from './CompactTab';

const ChartMatch = ({
  isMenuClosed,
  setIsMenuClosed,
}: Pick<NavigationTab, 'isMenuClosed' | 'setIsMenuClosed'>) => {
  const link = '/design-system/chart-match';

  if (isMenuClosed)
    return <CompactTab icon={<ChartMatchSVG />} setIsMenuClosed={setIsMenuClosed} href={link} />;

  return (
    <li>
      <NavLink to={link} className={({ isActive }) => (isActive ? 'active' : '')}>
        <div>
          <ChartMatchSVG />
          <span>ChartMatch</span>
        </div>
      </NavLink>
    </li>
  );
};

export default ChartMatch;
